import { render, staticRenderFns } from "./dangerGoodsForTeacher.vue?vue&type=template&id=54f3af1e&scoped=true"
import script from "./dangerGoodsForTeacher.vue?vue&type=script&lang=js"
export * from "./dangerGoodsForTeacher.vue?vue&type=script&lang=js"
import style0 from "./dangerGoodsForTeacher.vue?vue&type=style&index=0&id=54f3af1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3af1e",
  null
  
)

export default component.exports